import { useTranslation } from 'react-i18next';
import AdminLayout from '../../../components/AdminLayout';
import ChatTable from '../../../components/ChatTable';

function AdminChats() {
  const { t } = useTranslation('admin');

  return (
    <AdminLayout title={t('chats.page-title')} description={t('chats.page-description')}>
      <ChatTable />
    </AdminLayout>
  );
}

export default AdminChats;
